import { render, staticRenderFns } from "./HistoryListView.vue?vue&type=template&id=14b5b31c"
import script from "./HistoryListView.vue?vue&type=script&lang=js"
export * from "./HistoryListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports